// src/theme/tokens.ts

// Colores del diseño
export const colors = {
  brand: {
    600: "#2342DE",
    500: "#0367FD",
    400: "#007AFF",
    300: "#00AEFF",
    200: "#89D1FF",
    100: "#BAE2FF",
    50: "#E2F4FF",
  },

  blue: {
    600: "#2342DE",
    500: "#0E2EFB",
    400: "#007AFF",
    300: "#00AEFF",
    200: "#89D1FF",
    100: "#BAE2FF",
    50: "#E2F4FF",
  },
  gray: {
    600: "#2A2B2E",
    500: "#303540",
    400: "#444A58",
    300: "#667085",
    200: "#A6AFC4",
    100: "#EBEFF9",
    50: "#F7F9FF",
    25: "#F7FBFB",
    0: "#FFFFFF",
  },
  red: {
    600: "#47000C",
    500: "#D8001B",
    400: "#FC0036",
    300: "#FF676C",
    200: "#FFB1B3",
    100: "#FFD7D6",
    50: "#FFE8EA",
    25: "#FFEDF0",
  },
  green: {
    600: "#004E1F",
    500: "#0D8A3A",
    400: "#30B14D",
    300: "#5DE06C",
    200: "#A8F18F",
    100: "#D8F7B2",
    50: "#EEFBDD",
    25: "#F4FDE8",
  },
  yellow: {
    600: "#663A00",
    500: "#B85C00",
    400: "#FC8C00",
    300: "#FFB76C",
    200: "#FFDA8D",
    100: "#FFEBC1",
    50: "#FFF8E5",
    25: "#FFFBF2",
  },
  accent: {
    500: "#D1FB01",
  },
};

// Familias tipográficas
export const fonts = {
  heading: `"Outfit", system-ui, sans-serif`,
  body: `"Outfit", system-ui, sans-serif`,
  mono: `Menlo, monospace`,
};

// Tamaños de fuente
export const fontSizes = {
  "display-2xl": "64px",
  "display-xl": "56px",
  "display-lg": "48px",
  "display-sm": "40px",
  "title-lg": "20px", // Adaptado: 20px para Title Large
  "title-md": "16px", // Adaptado: 16px para Title Medium
  "title-sm": "16px", // Adaptado: 16px para Title Small
  "body-lg": "16px",
  "body-md": "14px",
  "body-sm": "12px",
  "caption-lg": "12px",
  "caption-sm": "10px",
};

// Pesos de fuente
export const fontWeights = {
  normal: 400,
  medium: 500,
  bold: 700,
  black: 900,
};

// Alturas de línea
export const lineHeights = {
  "display-2xl": "1.1",
  "display-xl": "1.1",
  "display-lg": "1.1",
  "display-sm": "1.2",
  "title-lg": "1.2", // Adaptado: 120% de la fuente
  "title-md": "1.2", // Adaptado: 120% de la fuente
  "title-sm": "1.2", // Adaptado: 120% de la fuente
  "body-lg": "1.5",
  "body-md": "1.5",
  "body-sm": "1.4",
  "caption-lg": "1.4",
  "caption-sm": "1.4",
};

// Espaciados entre letras
export const letterSpacings = {
  tighter: "-0.5px",
  normal: "0",
  wider: "0.5px",
};

// Estilos semánticos de texto
export const textStyles = {
  "display-2xl": {
    fontSize: "display-2xl",
    fontWeight: "normal",
    lineHeight: "display-2xl",
    letterSpacing: "normal",
  },
  "display-xl": {
    fontSize: "display-xl",
    fontWeight: "normal",
    lineHeight: "display-xl",
    letterSpacing: "normal",
  },
  "display-lg": {
    fontSize: "display-lg",
    fontWeight: "normal",
    lineHeight: "display-lg",
    letterSpacing: "normal",
  },
  "display-sm": {
    fontSize: "display-sm",
    fontWeight: "normal",
    lineHeight: "display-sm",
    letterSpacing: "normal",
  },
  "title-lg": {
    fontSize: "title-lg",
    fontWeight: "medium",
    lineHeight: "title-lg",
    letterSpacing: "normal",
  },
  "title-md": {
    fontSize: "title-md",
    fontWeight: "medium",
    lineHeight: "title-md",
    letterSpacing: "normal",
  },
  "title-sm": {
    fontSize: "title-sm",
    fontWeight: "medium",
    lineHeight: "title-sm",
    letterSpacing: "normal",
  },
  "body-lg": {
    fontSize: "body-lg",
    fontWeight: "normal",
    lineHeight: "body-lg",
  },
  "body-md": {
    fontSize: "body-md",
    fontWeight: "normal",
    lineHeight: "body-md",
  },
  "body-sm": {
    fontSize: "body-sm",
    fontWeight: "normal",
    lineHeight: "body-sm",
  },
  "caption-lg": {
    fontSize: "caption-lg",
    fontWeight: "medium",
    lineHeight: "caption-lg",
  },
  "caption-sm": {
    fontSize: "caption-sm",
    fontWeight: "medium",
    lineHeight: "caption-sm",
  },
};
